import React, { useEffect } from "react";
import { CenteredContainer } from "../../components/CenteredContainer/CenteredContainer";
import { PageBanner } from "../../components/PageBanner/PageBanner";
import { useDispatch, useSelector } from "react-redux";
import { styles } from "./UseCasesView.styles";
import Box from "@material-ui/core/Box/Box";
import Paper from "@material-ui/core/Paper/Paper";
import Tab from "@material-ui/core/Tab/Tab";
import Tabs from "@material-ui/core/Tabs/Tabs";
import { UseCaseCategoryView } from "./UseCasesCategoryView";
import { useParams } from "react-router-dom";
import UseCaseCategoryModel from "../../../models/useCase/UseCaseCategoryModel";
import * as UseCasesAction from "../../../stores/useCases/UseCasesAction";
import UseCaseModel from "../../../models/useCase/UseCaseModel";
import { CircularProgress, Typography, withStyles, WithStyles } from "@material-ui/core";
import { selectRequesting } from "../../../selectors/requesting/RequestingSelector";

interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`download-centre-tabpanel-${index}`}
            aria-labelledby={`download-centre-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={0}>{children}</Box>}
        </div>
    );
}

export interface IUseCasesViewProps extends WithStyles<typeof styles> {}

export const UseCasesViewPure: React.FunctionComponent<IUseCasesViewProps> = ({ classes }: IUseCasesViewProps) => {
    const { categoryId } = useParams();
    const dispatch = useDispatch();

    const useCasesFromState = useSelector(state => state.useCases.useCases);
    const categoriesFromState = useSelector(state => state.useCases.categories);

    let categories: UseCaseCategoryModel[];
    if (categoriesFromState) {
        categories = Object.values(categoriesFromState);
    }

    let useCases: UseCaseModel[];
    if (useCasesFromState) {
        useCases = Object.values(useCasesFromState);
    }

    const selectedCategory =
        categoryId === undefined
            ? categories?.[0]
            : categories?.find(category => category?.id === parseInt(categoryId));

    const getTab = (categoryId: number): number => {
        return categories?.findIndex(c => c.id === categoryId);
    };

    const [value, setValue] = React.useState(getTab(selectedCategory?.id) || 0);

    useEffect(() => {
        dispatch(UseCasesAction.requestAllUseCases());
        dispatch(UseCasesAction.requestAllCategories());
    }, [dispatch]);

    const isRequesting = useSelector(state =>
        selectRequesting(state, [UseCasesAction.REQUEST_ALL_USE_CASES, UseCasesAction.REQUEST_ALL_CATEGORIES])
    );

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setValue(newValue);
    };

    return (
        <>
            <PageBanner title="Use cases" isPublic />
            <CenteredContainer>
                <Typography variant="h6" gutterBottom>
                    Follow the use cases provided by our expert Stefan Schlamp, Head of Quantitative Analytics at
                    Deutsche Börse Market Data + Services, based on data from our analytics offering.
                </Typography>
                <div className={classes.gap}></div>
                {isRequesting ? (
                    <div className={classes.center}>
                        <CircularProgress color="inherit" className={classes.center} />
                    </div>
                ) : (
                    <Paper square>
                        <Tabs value={value} indicatorColor="primary" textColor="primary" onChange={handleChange}>
                            {categories?.map((category, index) => {
                                return <Tab key={index} label={category.name} />;
                            })}
                        </Tabs>
                        <div className={classes.gap}></div>
                    </Paper>
                )}
                {!isRequesting &&
                    categories?.map((category, index) => {
                        const categoryUseCases = useCases?.filter(useCase =>
                            useCase.categories?.includes(category?.id)
                        );

                        return (
                            <TabPanel value={value} key={category.id} index={index}>
                                <UseCaseCategoryView useCases={categoryUseCases} />
                            </TabPanel>
                        );
                    })}
            </CenteredContainer>
        </>
    );
};

export const UseCasesView = withStyles(styles)(UseCasesViewPure);
